import { User, UserContact, UserCredentials, UserList } from "pwapi";

export const getUserNameStringWithCredentials = (
  user:
    | User
    | UserContact
    | UserCredentials
    | (UserList & { credentials?: string }),
  isFirstNameLastName: boolean = false
): string => {
  const credentials = user.userprofile?.credentials || user.credentials;
  return isFirstNameLastName
    ? `${user.first_name} ${user.last_name}${
        credentials ? `, ${credentials}` : ""
      }`
    : `${user.last_name}, ${user.first_name} ${credentials ? credentials : ""}`;
};
